/**
 * @param {Function} hitAxios
 * @param {number} jobId
 */
export async function deleteVideoJob(hitAxios, jobId) {
  const res = await hitAxios({
    path: "/api/video-studio/jobs/delete",
    post: true,
    obj: { id: jobId },
    showLoading: false,
    showSnackbar: false,
  });

  if (res?.logout) {
    throw new Error("Session expired. Please sign in again.");
  }
  if (!res?.data?.success) {
    throw new Error(res?.data?.msg || "Could not delete video.");
  }
  return res.data;
}
